import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@/shared/components/ui/Button';
import { useAuthStore } from '@/store/authStore';
import './NotFound.css';
const NotFound = () => {
  const navigate = useNavigate();
  const userId = useAuthStore((state) => state.user_id);
  const isLoggedIn = Boolean(userId);

  return (
    <main className="w-full min-h-screen h-auto flex flex-col justify-center items-center bg-[linear-gradient(180deg,_#017AFF_-119.35%,_#F3F6FE_62.65%)] px-6 text-center gap-6">
      <h1 className="text-[180px] leading-none font-bold text-white drop-shadow-sm teks-goyang">
        404
      </h1>
      <div className="flex flex-col gap-2">
        <p className="text72 text-text-grey">Page Not Found</p>
        <p className="text-text-grey ">
          Sorry, the page you are looking for doesn’t exist or has been moved.
        </p>
      </div>
      <Button
        label="Back to Home"
        variant="default"
        className="btn-fill-blue rounded-full hover:opacity-90 cursor-pointer px-8"
        onClick={() => navigate(isLoggedIn ? '/' : '/introduction')}
      />
    </main>
  );
};

export default NotFound;
